import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageClientComponent } from './manageclient.component';
import { AuthGuardService as AuthGuard } from './../../auth-guard.service';

const routes: Routes = [
  {
    path: 'manageclient',
    component: ManageClientComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageClientRoutingModule { }

